import React, { useRef, useContext } from "react";
import PandS_loader from "./PopChild/PandS_loader";
import ProjectContext from "../../context/ProjectContext";
const PreviewProps = ({
  UnloadedCounter,
  setUnloadedCounter,
  LoadCounter,
  setLoadCounter,
  value,
  TickerStart,
  TickerPosition,
  zInd,
  CanvasDisplay,
  index,
  onePX,
}) => {
  const PropRef = useRef(null);
  const { projectEditorZoom } = useContext(ProjectContext);

  return (
    <>
      {value.opc === 1 && (
        <>
          <div
            className={"changer EditStart " + value.InClass + value.OutClass}
            id={"Preview-" + value.AnimationId}
            style={{
              display: !CanvasDisplay
                ? value.player
                  ? "inline-block"
                  : "none"
                : TickerStart
                ? value.startPositionOnTimeline <= TickerPosition &&
                  value.startPositionOnTimeline + value.widthOnTimeline >=
                    TickerPosition
                  ? "inline-block"
                  : "none"
                : value.startPositionOnTimeline + value.startTransitionWidth <=
                    TickerPosition &&
                  value.startPositionOnTimeline +
                    value.widthOnTimeline -
                    value.startTransitionWidth >=
                    TickerPosition
                ? "inline-block"
                : "none",
              VendorAnimationDuration: ".5s",
              zIndex: zInd,
              transform: `rotate(${value.rotateAngle}deg) ` + value.flip,
              left: value.x,
              top: value.y,
              height: value.height,
              width: value.width,
            }}
            ref={PropRef}
          >
            <PandS_loader
              UnloadedCounter={UnloadedCounter}
              setUnloadedCounter={setUnloadedCounter}
              LoadCounter={LoadCounter}
              setLoadCounter={setLoadCounter}
              key={index.toString()}
              value={value}
              onePxEquivalent={onePX}
            />
          </div>
        </>
      )}
    </>
  );
};

export default PreviewProps;
